module.exports = __webpack_public_path__ + "img/ring_y_0_1_0.aa8bd395.png";